import React, { useEffect } from "react";

import { HeaderDesktopContent } from "@faire/retailer/components/Header/desktop/HeaderDesktopContent";
import { NavigationLinksBar } from "@faire/retailer/components/Header/desktop/NavigationLinksBar/NavigationLinksBar";
import { HeaderContainer } from "@faire/retailer/components/Header/styled";
import { useIsSemDiscoverPage } from "@faire/retailer/lib/useIsSemDiscoverPage";
import { useAssignSettingHeaderNavSignupCTACopy } from "@faire/retailer/settings/useSettingHeaderNavSignupCTACopy";

export const HeaderDesktop = ({ className }: { className?: string }) => {
  const isSemDiscoverPage = useIsSemDiscoverPage();

  const assignSettingHeaderNavSignupCTACopy =
    useAssignSettingHeaderNavSignupCTACopy();

  useEffect(() => {
    assignSettingHeaderNavSignupCTACopy();
  }, [assignSettingHeaderNavSignupCTACopy]);

  return (
    <HeaderContainer className={className}>
      <HeaderDesktopContent />
      {isSemDiscoverPage ? null : <NavigationLinksBar />}
    </HeaderContainer>
  );
};
